import * as React from "react";
import { useFieldProps } from "src/hooks/form/useField";
import { useSelect, useStaticSelect } from "src/hooks/form/useSelect";
import { fetchAddresses } from "src/api/organisationProfiling";

const usePlant = <T>(
  props: useFieldProps<T>,
) => {
  const field = useSelect(
    props,
    () => fetchAddresses({ locationType: 'PLANT' }),
    (data) => data?.map((el) => ({ key: el.id, label: el.name })) || []
  );

  return field;
};

export default usePlant;
